import { MARKET_DE } from "@/seo/marketDe";
import { MARKET_FR } from "@/seo/marketFr";

export const MARKET = { ...MARKET_DE, ...MARKET_FR };
export const MARKET_SLUGS = Object.keys(MARKET);
export const marketFor = (lang) => Object.values(MARKET).filter((m) => m.lang === lang);
